import { createContext, useContext } from 'react';

interface BottomSheetAnimationContextValue {
  isAnimationSettled: boolean;
}

export const BottomSheetAnimationContext = createContext<BottomSheetAnimationContextValue>({ isAnimationSettled: true });

export const useBottomSheetAnimation = (): BottomSheetAnimationContextValue => useContext(BottomSheetAnimationContext);
